webpackJsonp([264598414423048],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};
	
	var Content = function Content(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    content
	  );
	};
	
	Content.propTypes = {
	  content: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = exports.AboutPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Content = __webpack_require__(41);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageTemplate = exports.AboutPageTemplate = function AboutPageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'section section--gradient' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-10 is-offset-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'title is-size-3 has-text-weight-bold is-bold-light' },
	              title
	            ),
	            _react2.default.createElement(PageContent, { className: 'content', content: content })
	          )
	        )
	      )
	    )
	  );
	};
	
	AboutPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  content: _propTypes2.default.string,
	  contentComponent: _propTypes2.default.func
	};
	
	var AboutPage = function AboutPage(_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(AboutPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: post.frontmatter.title,
	    content: post.html
	  });
	};
	
	AboutPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = AboutPage;
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-e6bd5831c49e40512a81.js